module.exports = __webpack_public_path__ + "media/images/glyphs/profile-alt-97fc1f915f2eaa74ecdee766e33e61d9.svg";